import React, { useReducer, useState } from "react";
import "./profil.scss";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import MapOutlined from "@mui/icons-material/MapOutlined";
import PasswordOutlinedIcon from "@mui/icons-material/PasswordOutlined";
import SupervisorAccountOutlinedIcon from "@mui/icons-material/SupervisorAccountOutlined";
import PhoneIphoneOutlinedIcon from "@mui/icons-material/PhoneIphoneOutlined";
import { Avatar, Box, Skeleton, Tooltip } from "@mui/material";
import EditProfilDialog from "./EditProfilDialog.tsx";
import { AdminType } from "../../types/UserTypes";
// import { adminData } from "../../data/data";
import { requestType } from "../../types/GlobalType";
import { useNavigate } from "react-router-dom";
import UpdatePswd from "./UpdatePswd.tsx";
import { catchErrorApiCall } from "../../_services/apiUtils";
import { accountService } from "../../_services/accountServices";
import user_api from "../../apiCaller/user.Caller";
import {
  MailOutline,
  MapsHomeWork,
  School,
  SentimentSatisfiedAlt,
} from "@mui/icons-material";
import ConnexionErrorDiv from "../../component/nodata/ConnexionErrorDiv.js";

const Profil = () => {
  const [openEdit, setOpenEdit] = useState<Boolean>(false);
  const [openPsw, setOpenPsw] = useState<boolean>(false);
  const [dataUser, setdataUser] = useState<AdminType>();
  // const [singleData, setSingleData] = useState<AdminType>();

  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: null,
  });

  // let pays: string = !!data?.pays ? data.pays : "CD";

  const [reducerValueOnUpdate, forceReloadOnUpdate] = useReducer(
    (x) => x + 1,
    0,
  );

  const navigate = useNavigate();

  // console.log(data);

  const fetchUserInfo = async () => {
    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();
    if (!token) return navigate("/login");

    let userId = accountService.getUserImei();
    if (!userId) return navigate("/login");

    // console.log(userId);

    try {
      const response = await user_api.getOne(userId, token);
      setdataUser(response.data.data);
      // console.log(response.data.data);

      setState({ ...state, isLoading: false });
    } catch (error) {
      setState({ ...state, isLoading: false });

      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }

      catchErrorApiCall(error);
    }
  };

  React.useEffect(() => {
    fetchUserInfo();
  }, [reducerValueOnUpdate]);

  return (
    <>
      {state.errorMessage === "ERR_NETWORK" ? (
        <ConnexionErrorDiv />
      ) : (
        <>
          {state.isLoading ? (
            <Box
              bgcolor="#eee"
              flex={5}
              p={1}
              height="100%"
              sx={{ marginLeft: "200px", marginTop: "66px" }}
            >
              <div className="profil">
                <div className="header">
                  <Avatar className="ico" />
                  <Skeleton width={250} height={30} variant="rectangular" />
                  <Skeleton width={150} height={20} variant="rounded" />
                  <Skeleton width={150} height={20} variant="rounded" />
                </div>
                <div className="body_sk">
                  <div className="box">
                    <div className="box_icon">
                      <MapOutlined className="ico2" />
                    </div>
                    <div className="box_info">
                      <Skeleton width={300} height={20} variant="rectangular" />
                      <Skeleton width={300} height={10} variant="rectangular" />
                    </div>
                  </div>
                  <div className="box">
                    <div className="box_icon">
                      <LocationOnOutlinedIcon className="ico2" />
                    </div>
                    <div className="box_info">
                      <Skeleton width={300} height={20} variant="rectangular" />
                      <Skeleton width={300} height={10} variant="rectangular" />
                    </div>
                  </div>
                  <div className="box">
                    <div className="box_icon">
                      <PhoneIphoneOutlinedIcon className="ico2" />
                    </div>
                    <div className="box_info">
                      <Skeleton width={300} height={20} variant="rectangular" />
                      <Skeleton width={300} height={10} variant="rectangular" />
                    </div>
                  </div>
                  <div className="box">
                    <div className="box_icon">
                      <PasswordOutlinedIcon className="ico2" />
                    </div>
                    <div className="box_info">
                      <Skeleton width={300} height={20} variant="rectangular" />
                      <Skeleton width={300} height={10} variant="rectangular" />
                    </div>
                  </div>
                  <div className="box">
                    <div className="box_icon">
                      <SupervisorAccountOutlinedIcon className="ico2" />
                    </div>
                    <div className="box_info">
                      <Skeleton width={300} height={20} variant="rectangular" />
                      <Skeleton width={300} height={10} variant="rectangular" />
                    </div>
                  </div>
                </div>
              </div>
            </Box>
          ) : (
            <Box
              bgcolor="#eee"
              flex={5}
              p={1}
              height="100%"
              sx={{ marginLeft: "200px", marginTop: "66px" }}
            >
              <div className="profil">
                <div className="links">
                  {/* <span className="editProfil">Modifier mot de passe</span> */}
                  <span className="editPass" onClick={() => setOpenPsw(true)}>
                    Modifier mot de passe
                  </span>
                </div>
                <div className="header">
                  <Avatar className="ico" />
                  <span className="username">
                    {`${dataUser?.nom?.toUpperCase()} ${dataUser?.postnom?.toUpperCase()} `}
                  </span>

                  <span className="email">
                    {dataUser?.email?.toLowerCase()}
                  </span>

                  <button
                    onClick={() => {
                      setOpenEdit(true);
                    }}
                  >
                    Modifier profil
                  </button>
                </div>
                <div className="body">
                  <div className="box">
                    <div className="box_icon">
                      <MapOutlined className="ico2" />
                    </div>
                    <div className="box_info">
                      <span className="main_info">Noms</span>
                      <div className="second_info">
                        <span>
                          <span>
                            {dataUser?.nom?.toUpperCase()}{" "}
                            {dataUser?.postnom?.toUpperCase()}{" "}
                            {dataUser?.prenom?.toUpperCase()}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="box">
                    <div className="box_icon">
                      <LocationOnOutlinedIcon className="ico2" />
                    </div>
                    <div className="box_info">
                      <span className="main_info">Adresse</span>
                      <div className="second_info">
                        <span>
                          {dataUser?.ville?.toUpperCase()}
                          {" / "}
                          {dataUser?.quartier?.toUpperCase()}
                          {" / "}
                          {dataUser?.avenue?.toUpperCase()}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="box">
                    <div className="box_icon">
                      <PhoneIphoneOutlinedIcon className="ico2" />
                    </div>
                    <div className="box_info">
                      <span className="main_info">Téléphone</span>
                      <div className="second_info">
                        <span>{dataUser?.telephone}</span>
                      </div>
                    </div>
                  </div>
                  <div className="box">
                    <div className="box_icon">
                      <MailOutline className="ico2" />
                    </div>
                    <div className="box_info">
                      <span className="main_info">Adresse mail</span>
                      <div className="second_info">
                        <span>{dataUser?.email}</span>
                      </div>
                    </div>
                  </div>
                  <div className="box">
                    <div className="box_icon">
                      <SentimentSatisfiedAlt className="ico2" />
                    </div>
                    <div className="box_info">
                      <span className="main_info">Genre</span>
                      <div className="second_info">
                        <span>
                          {dataUser?.sexe?.toLowerCase() == "m"
                            ? "Homme"
                            : "Femme"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="body">
                  <div className="box">
                    <div className="box_icon">
                      <MapsHomeWork className="ico2" />
                    </div>
                    <div className="box_info">
                      <span className="main_info">Fonction</span>
                      <div className="second_info">
                        <span>
                          {dataUser?.fonction_designation?.toUpperCase()}{" "}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="box">
                    <div className="box_icon">
                      <LocationOnOutlinedIcon className="ico2" />
                    </div>
                    <div className="box_info">
                      <span className="main_info">Domaine d'étude</span>
                      <div className="second_info">
                        <span>
                          {dataUser?.domaine_designation?.toUpperCase()}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="box">
                    <div className="box_icon">
                      <School className="ico2" />
                    </div>
                    <div className="box_info">
                      <span className="main_info">Niveau d'étude</span>
                      <div className="second_info">
                        <span>
                          {dataUser?.grade_designation?.toUpperCase()}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="box">
                    <div className="box_icon">
                      <PasswordOutlinedIcon className="ico2" />
                    </div>
                    <div className="box_info">
                      <span className="main_info">Mot de passe</span>
                      <div className="second_info">
                        <span>
                          ••••••••••••••••
                          <Tooltip
                            title="Changer mot de passe"
                            placement="right"
                          >
                            <span
                              className="ico"
                              onClick={() => setOpenPsw(true)}
                            >
                              Edit
                            </span>
                          </Tooltip>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="box">
                    <div className="box_icon">
                      <SupervisorAccountOutlinedIcon className="ico2" />
                    </div>
                    <div className="box_info">
                      <span className="main_info">Rôle</span>
                      <div className="second_info">
                        <span>{"Admin"}</span>
                      </div>
                    </div>
                  </div>
                </div>
                {openEdit && (
                  <EditProfilDialog
                    setOpen={setOpenEdit}
                    data={dataUser}
                    dispatchReload={forceReloadOnUpdate}
                  />
                )}
                {openPsw && (
                  <UpdatePswd
                    setOpen={setOpenPsw}
                    data={dataUser}
                    dispatchReload={forceReloadOnUpdate}
                  />
                )}
              </div>
            </Box>
          )}
        </>
      )}
    </>
  );
};

export default Profil;
